import React from "react";

const ThemeSelectorContext = React.createContext()

export default ThemeSelectorContext